import DrawModeBase from '@/lib/mapbox/draw-mode-base'

/**
 * Trim mode
 */
class TrimMode extends DrawModeBase {
  /**
   * @inheritDoc
   */
  onSetup(lineGeoJson) {
    this._state = {
      originalCoordinates: [...lineGeoJson.geometry.coordinates],
    }
  }

  /**
   * @inheritDoc
   */
  toDisplayFeatures(geoJson) {
    return [
      this._formatDisabledLine(geoJson),
      geoJson,
      this._formatStartPoint(geoJson),
      this._formatEndPoint(geoJson),
    ]
  }

  /**
   * Formats the trim start point
   * @param {Object} lineGeoJson - The line feature GeoJSON.
   * @returns {Object} Point Feature GeoJson representing the trim start point
   */
  _formatStartPoint(geoJson) {
    return {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: geoJson.geometry.coordinates[0],
      },
      properties: {
        meta: 'trim-start',
      },
    }
  }

  /**
   * Formats the trim start point
   * @param {Object} lineGeoJson - The line feature GeoJSON.
   * @returns {Object} Point Feature GeoJson representing the trim end point
   */
  _formatEndPoint(geoJson) {
    return {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates:
          geoJson.geometry.coordinates[geoJson.geometry.coordinates.length - 1],
      },
      properties: {
        meta: 'trim-end',
      },
    }
  }

  /**
   * Formats the original lines so user can see the sections they will be removing
   * @returns {Object} LineString Feature GeoJson representing the line before it is trimmed
   */
  _formatDisabledLine(geoJson) {
    return {
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: this._state.originalCoordinates,
      },
      properties: {
        color: 'grey',
        style: geoJson.properties.style,
        weight: geoJson.properties.weight,
      },
    }
  }
}

export default TrimMode
